module.exports = __webpack_public_path__ + "static/img/13.0a00c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/13.png
// module id = gXiM
// module chunks = 0